import { render, staticRenderFns } from "./LongNovel.vue?vue&type=template&id=5ea4e308"
import script from "./LongNovel.vue?vue&type=script&lang=js"
export * from "./LongNovel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports